export enum Floor {
  BodyHub,
  Heart,
  Kidneys,
  Pancreas,
  UnknownBottom
}